import { defineStore } from "pinia";
import { type AIChatBotKeys, type EnvConfig } from "@/constants/interfaces";
import { ref } from "vue";
import { isValidJSONString } from "@/utilities/utilities";
import { useGlobalStore } from "./globalStore";

export const useEnvConfigStore = defineStore('useEnvConfigStore',()=>{
  const envInfo = ref <EnvConfig>()
  function setApiUrls(res:EnvConfig) {
    envInfo.value = res
  }
  const aiChatBotKeys = ref<AIChatBotKeys>()

  function setAIChatBotConfigKeys(configKeys:AIChatBotKeys){
    const {CurrentSpanBotUSPSAccessKey,CurrentSpanBotAccessKey,CurrentSpanBotReturnStatusAccessKey,CurrentSpanBotYoutubeAccessKey,CurrentSpanBotUrl} = useGlobalStore()

    aiChatBotKeys.value = configKeys
    aiChatBotKeys.value.FeatureFlags = isValidJSONString(aiChatBotKeys.value.FeatureFlags) ? JSON.parse(aiChatBotKeys.value.FeatureFlags) : {}
    aiChatBotKeys.value.SpanBotAccessKey = isValidJSONString(aiChatBotKeys.value.SpanBotAccessKey)? JSON.parse(aiChatBotKeys.value.SpanBotAccessKey) :aiChatBotKeys.value.SpanBotAccessKey

    // if(!aiChatBotKeys.value.FeatureFlags?.IsEnableAdminBot){
    //     CurrentSpanBotAccessKey.value = aiChatBotKeys.value?.ActiveAI == "OPENAI" ? aiChatBotKeys.value.SpanBotAccessKey : aiChatBotKeys.value.SecondarySpanBotAccessKey
      
    //   }
    //   CurrentSpanBotUSPSAccessKey.value = aiChatBotKeys.value?.ActiveAI == "OPENAI" ? aiChatBotKeys.value.SpanBotUSPSAccessKey : aiChatBotKeys.value.SecondarySpanBotUSPSAccessKey
    //   CurrentSpanBotReturnStatusAccessKey.value =aiChatBotKeys.value?.ActiveAI == "OPENAI" ?  aiChatBotKeys.value.SpanBotReturnStatusAccessKey :   aiChatBotKeys.value.SecondarySpanBotReturnStatusAccessKey
    //   CurrentSpanBotYoutubeAccessKey.value = aiChatBotKeys.value?.ActiveAI == "OPENAI" ? aiChatBotKeys.value.SpanBotYoutubeAccessKey :   aiChatBotKeys.value.SecondarySpanBotYoutubeAccessKey
    //   CurrentSpanBotUrl.value = aiChatBotKeys.value?.ActiveAI == "OPENAI" ? aiChatBotKeys.value.SpanBotUrl :   aiChatBotKeys.value.SecondarySpanBotUrl

    if(!aiChatBotKeys.value.FeatureFlags?.IsEnableAdminBot){
        CurrentSpanBotAccessKey.value = aiChatBotKeys.value.SpanBotAccessKey 
      
      }
      CurrentSpanBotUSPSAccessKey.value =  aiChatBotKeys.value.SpanBotUSPSAccessKey 
      CurrentSpanBotReturnStatusAccessKey.value =  aiChatBotKeys.value.SpanBotReturnStatusAccessKey
      CurrentSpanBotYoutubeAccessKey.value =  aiChatBotKeys.value.SpanBotYoutubeAccessKey 
      CurrentSpanBotUrl.value =  aiChatBotKeys.value.SpanBotUrl
    
  }
  
  return{
    envInfo,
    setApiUrls,
    aiChatBotKeys,
    setAIChatBotConfigKeys
  }
},
{
  persist:false
}
)